/* eslint-disable */
import * as shared from '../shared';

googletag.cmd.push(function () {
  // institution_index_bottom
  googletag.defineSlot(
    '/21678620621/medicalnote_sp_hospital_searchtop_bottom_20181003',
    shared.spBottomSizes(),
    'div-gpt-ad-1538556890372-0'
  ).defineSizeMapping(shared.setDfpResponsiveSize()).addService(googletag.pubads());

  shared.setDiseaseKeyValue();
  shared.setSymptomKeyValue();
  shared.setContentTypeKeyValue();
  shared.setHospitalDepartmentKeyValue();
  shared.setEnvKeyValue();
  shared.setAdTagKeyValue();
  shared.setPathKeyValue();
  shared.setDoctorKeyValue();

  if (!shared.isMobile()) googletag.pubads().enableSingleRequest();
  googletag.pubads().collapseEmptyDivs();
  googletag.enableServices();
});
/* eslint-enable */
